import React from 'react';
import PropTypes from 'prop-types';
import RewindIcon from 'components/Icons/rewind';
import FFIcon from 'components/Icons/ff';
import { ReactComponent as NextIcon } from 'assets/img/player-icon-next.svg';
import { ReactComponent as PrevIcon } from 'assets/img/player-icon-prev.svg';
import { ReactComponent as EpgIcon } from 'assets/img/player-icon-epg.svg';
import { ReactComponent as OnAirIcon } from 'assets/img/player-icon-onair.svg';
import { ReactComponent as PlayIcon } from 'assets/img/player-icon-play.svg';
import { ReactComponent as PauseIcon } from 'assets/img/player-icon-pause.svg';
import { ReactComponent as WatchlistIcon } from 'assets/img/player-icon-favourite.svg';
import { ReactComponent as SettingsIcon } from 'assets/img/player-icon-settings.svg';
import { ReactComponent as CrossIcon } from 'assets/img/player-icon-cross.svg';

import {
  StyledWatchlistButton,
  StyledPrevButton,
  StyledPrevProgramPopup,
  StyledRewindButton,
  StyledPlayButton,
  StyledEPGButton,
  StyledFFButton,
  StyledNextButton,
  StyledNextProgramPopup,
  StyledSettingsButton,
  StyledFavoritePanelConfirmButton,
  StyledFavoriteButtonText,
  StyledFavoritePanelCancelButton,
  StyledProgramPopup,
  StyledOnAirButton,
  StyledCancelPopup,
} from './StyledComponents';

export const FavoriteButton = ({ onEnter, disabled, isActive, isHidden }) => {
  return (
    <StyledWatchlistButton
      onEnter={!disabled && onEnter}
      isActive={isActive}
      isNotAvailable={disabled}
      isHidden={isHidden}
      focusOnMouseEnter
    >
      <WatchlistIcon />
    </StyledWatchlistButton>
  );
};

FavoriteButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isActive: PropTypes.bool,
};

export const PrevButton = ({ onEnter, disabled, hint, isHidden }) => {
  return (
    <StyledPrevButton
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      isHidden={isHidden}
      focusOnMouseEnter
    >
      <PrevIcon />
      {!disabled && <StyledPrevProgramPopup>{hint}</StyledPrevProgramPopup>}
    </StyledPrevButton>
  );
};

PrevButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isHidden: PropTypes.bool,
  hint: PropTypes.string,
};

export const RewindButton = ({ onEnter, disabled, isHidden }) => {
  return (
    <StyledRewindButton
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      isHidden={isHidden}
      focusOnMouseEnter
    >
      <RewindIcon />
    </StyledRewindButton>
  );
};

RewindButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isHidden: PropTypes.bool,
};

export const PlayButton = ({ onEnter, id, disabled, isPlaying, className, isHidden }) => {
  return (
    <StyledPlayButton
      onEnter={!disabled && onEnter}
      id={id}
      isNotAvailable={disabled}
      className={className}
      isHidden={isHidden}
      focusOnMouseEnter
    >
      {isPlaying ? <PauseIcon /> : <PlayIcon />}
    </StyledPlayButton>
  );
};

PlayButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  isPlaying: PropTypes.bool,
};

export const FFButton = ({ onEnter, disabled, isHidden }) => {
  return (
    <StyledFFButton
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      isHidden={isHidden}
      focusOnMouseEnter
    >
      <FFIcon />
    </StyledFFButton>
  );
};

FFButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  isHidden: PropTypes.bool,
  disabled: PropTypes.bool,
};

export const NextButton = ({ onEnter, disabled, hint, isHidden }) => {
  return (
    <StyledNextButton
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      isHidden={isHidden}
      focusOnMouseEnter
    >
      <NextIcon />
      {!disabled && <StyledNextProgramPopup>{hint}</StyledNextProgramPopup>}
    </StyledNextButton>
  );
};

NextButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isHidden: PropTypes.bool,
  hint: PropTypes.string,
};

export const SettingButton = ({ onEnter, disabled }) => {
  return (
    <StyledSettingsButton
      onEnter={!disabled && onEnter}
      isNotAvailable={disabled}
      focusOnMouseEnter
    >
      <SettingsIcon />
    </StyledSettingsButton>
  );
};

SettingButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export const FavoritePanelConfirmButton = ({ title, onEnter }) => {
  return (
    <StyledFavoritePanelConfirmButton onEnter={onEnter} focusOnMouseEnter>
      <StyledFavoriteButtonText>{title}</StyledFavoriteButtonText>
    </StyledFavoritePanelConfirmButton>
  );
};

FavoritePanelConfirmButton.propTypes = {
  title: PropTypes.string.isRequired,
  onEnter: PropTypes.func.isRequired,
};

export const FavoritePanelCancelButton = ({ onEnter, id, hint }) => {
  return (
    <StyledFavoritePanelCancelButton onEnter={onEnter} focusOnMouseEnter id={id}>
      <CrossIcon />
      <StyledCancelPopup>{hint}</StyledCancelPopup>
    </StyledFavoritePanelCancelButton>
  );
};

FavoritePanelCancelButton.propTypes = {
  onEnter: PropTypes.func.isRequired,
};

export const EPGButton = ({ onEnter, hint, id }) => {
  return (
    <StyledEPGButton onEnter={onEnter} id={id} focusOnMouseEnter>
      <EpgIcon />
      <StyledProgramPopup>{hint}</StyledProgramPopup>
    </StyledEPGButton>
  );
};

export const OnAirButton = ({ id, onEnter, disabled, isHidden, text }) => {
  return (
    <StyledOnAirButton id={id} onEnter={!disabled && onEnter} isHidden={isHidden} focusOnMouseEnter>
      <OnAirIcon />
      {text}
    </StyledOnAirButton>
  );
};
